import { Label } from '~shared/shadcn/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '~shared/shadcn/ui/select';
import { Switch } from '~shared/shadcn/ui/switch';

import { isEventAutoHideGraceHours } from '../events.helpers';
import {
  EVENT_AUTO_HIDE_GRACE_HOUR_VALUES,
  EVENT_AUTO_HIDE_GRACE_LABEL,
  EventAutoHideGraceHours,
} from '../events.types';

export function EventPortalVisibilityFields({
  hide,
  onHideChange,
  hideLabel,
  autoHideAfterEnd,
  onAutoHideChange,
  autoHideGraceHours,
  onGraceChange,
  showGrace,
  visibilityHint,
}: {
  hide: boolean;
  onHideChange: (hide: boolean) => void;
  hideLabel: string;
  autoHideAfterEnd: boolean;
  onAutoHideChange: (value: boolean) => void;
  autoHideGraceHours: EventAutoHideGraceHours;
  onGraceChange: (hours: EventAutoHideGraceHours) => void;
  showGrace: boolean;
  visibilityHint: string;
}) {
  return (
    <div className='space-y-3'>
      <div className='flex items-center space-x-2'>
        <Switch
          id='hidden'
          checked={hide}
          onCheckedChange={onHideChange}
        />
        <Label htmlFor='hidden'>{hideLabel}</Label>
      </div>
      <div className='flex items-center space-x-2'>
        <Switch
          id='auto-hide-after-end'
          checked={autoHideAfterEnd}
          onCheckedChange={onAutoHideChange}
        />
        <Label htmlFor='auto-hide-after-end'>
          Auto-hide from portal after event ends
        </Label>
      </div>
      {showGrace ? (
        <div className='space-y-1 pl-8'>
          <Label htmlFor='auto-hide-grace'>Keep visible for</Label>
          <Select
            value={String(autoHideGraceHours)}
            onValueChange={(value) => {
              const hours = Number(value);
              if (isEventAutoHideGraceHours(hours)) {
                onGraceChange(hours);
              }
            }}
          >
            <SelectTrigger id='auto-hide-grace' className='w-48'>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {EVENT_AUTO_HIDE_GRACE_HOUR_VALUES.map((hours) => (
                <SelectItem key={hours} value={String(hours)}>
                  {EVENT_AUTO_HIDE_GRACE_LABEL[hours]} after end
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>
      ) : null}
      <p className='text-xs text-muted-foreground'>{visibilityHint}</p>
    </div>
  );
}
